<template>
  <v-autocomplete
    v-model="selectedLayout"
    label="Image Layout"
    item-text="descricao"
    item-value="id"
    return-object
    :items="arrayLayouts"
    :dark="dark"
    :multiple="multiple"
    :rules="validate ? [rules.required] : ''"
    chips
    @change="$emit('onChanged', $event)"
  >
    <template v-if="multiple" v-slot:prepend-item>
      <v-btn color="blue darken-2" text depressed @click="selectAll()"
        >Marcar Todos</v-btn
      >&nbsp;
      <v-btn color="blue darken-2" text depressed @click="selectAll(false)"
        >Desmarcar Todos</v-btn
      >

      <v-divider class="mt-2 mb-2"></v-divider>
    </template>

    <template v-slot:selection="{ item, index }">
      <v-chip v-if="index === 0">
        <span>{{ item.descricao }}</span>
      </v-chip>
      <span v-if="index === 1" class="red--text caption"
        >(+{{ selectedLayout.length - 1 }})</span
      >
    </template>

    <template v-slot:item="data">
      <v-list-item-avatar>
        <img :src="data.item.url" />
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title>{{ data.item.descricao }}</v-list-item-title>
      </v-list-item-content>
    </template>
  </v-autocomplete>
</template>

<script>
import rules from "@/utils/rules";
import { LayoutImage } from "@/services/materiais";

export default {
  name: "SelectImageLayout",

  props: {
    multiple: {
      type: Boolean,
      default: false
    },

    dark: {
      type: Boolean,
      default: false
    },

    campanha: {
      type: String,
      required: false
    },

    mounted: {
      type: Boolean,
      default: false
    },

    validate: {
      type: Boolean,
      default: true
    },

    independent: {
      type: Boolean,
      default: false
    },

    selected: {
      type: String || Array,
      default: null
    }
  },

  data() {
    return {
      selectedLayout: this.selected || [],
      arrayLayouts: [],

      rules: rules
    };
  },

  methods: {
    async getByCampanha() {
      try {
        let layouts = await new LayoutImage().getByCampanha(this.campanha);
        this.arrayLayouts = layouts;
      } catch (error) {
        console.error(error);
        this.$toast.error(error);
      }
    },

    selectAll(all = true) {
      if (all) {
        this.selectedLayout = this.arrayLayouts.map(value => value.id);
        this.$emit("onChanged", this.arrayLayouts);
      } else {
        this.selectedLayout = [];
        this.$emit("onChanged", []);
      }
    }
  },

  watch: {
    campanha: {
      handler() {
        this.selectedLayout = [];
        this.getByCampanha();
      },
      deep: true
    }
  },

  mounted() {
    // if(this.independent) this.getAll()
  }
};
</script>
